import Card from "@/components/Card";
import Dropdown, { Item } from "@/components/form/Dropdown";
import { getYears, months } from "@/utils/date-format";
import React, { useEffect } from "react";
import PayslipDataTable from "./payslip-data-table/PayslipDataTable";

function PayslipPage() {
  return (
    <div className="flex flex-col h-[100vh] w-full p-4 gap-4">
      <Card styles="flex-1">
        <div className="flex gap-2 w-full flex-col p-5">
          <div className="flex flex-col gap-3">
            <div className="font-bold mt-2 sm:text-2xl text-l">Pay Records</div>
            <div className="text-sm text-gray-500">
              View your past processed payslips.
            </div>
          </div>
          <div className="w-full h-full flex-1 flex overflow-x-auto">
            <PayslipDataTable />
          </div>
        </div>
      </Card>
    </div>
  );
}

export default PayslipPage;
